import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getUser } from "generated/api/user";

const userApi = getUser();

/**
 * Hook for performing user logout on the server and clearing local React Query cache.
 */
export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => userApi.logout(),
    onSettled: () => queryClient.clear(),
  });
};
